<template>
  <v-dialog
    v-model="opened"
    width="700"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-flex xs12>
      <v-card :loading="loading" color="#fff" class="pa-4 subscription-modern-card">
        <v-flex xs12>
          <div class="expande-horizontal wrap">
            <v-flex xs12>
              <v-form ref="formSubscription">
                <v-flex xs12>
                  <div class="fonte expande-horizontal subscription-header">
                    <div class="expande-horizontal column" style="flex-wrap: nowrap;">
                      <h1 style="font-size: 30pt; color: #333;" class="fonte fonte-bold">
                        {{ $helper.formataSaldo(subscription.plan_id.value_cents || 0) }}
                      </h1>
                      <span style="font-size: 14pt; margin-top: -18px;" class="fonte grey--text">
                        Plano {{ subscription.plan_id.name || '-' }}
                      </span>
                      <v-chip class="fonte white--text mb-3" :color="subscription.current_status === 'active' ? 'green' : 'blue'">
                        <v-icon size="20" class="mr-1">{{ subscription.current_status === 'active' ? 'mdi-check' : 'mdi-information' }}</v-icon>
                        Sua assinatura esta {{ filterStatusSubscription(subscription.current_status) }}
                      </v-chip>
                      <span v-if="warning" class="fonte red--text">
                        {{ message }}
                      </span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn @click="close" icon>
                      <v-icon color="orange" size="30">mdi-close</v-icon>
                    </v-btn>
                  </div>

                  <v-divider class="mb-2"></v-divider>
                  <v-timeline dense align-top>
                    <v-timeline-item fill-dot small :icon-color="$theme.primary" icon="mdi-flag" color="#f2f2f2">
                      <span class="fonte grey--text">
                        voce entrou
                        <span style="font-size: 14pt; color: #333;" class="fonte-bold">{{ $moment(subscription.created_at).format('DD/MM/YYYY [as] HH:mm') }}</span>
                      </span>
                    </v-timeline-item>

                    <v-timeline-item v-if="subscription.current_status !== 'active'" fill-dot small :icon-color="$theme.primary" icon="mdi-credit-card-outline" color="#f2f2f2">
                      <h4 class="fonte black--text mb-3">Ative sua assinatura agora:</h4>

                      <v-flex xs12 class="mb-4">
                        <v-btn
                          small
                          class="mr-2"
                          :color="methodSelected === 'card' ? 'blue' : 'grey lighten-2'"
                          :dark="methodSelected === 'card'"
                          @click="methodSelected = 'card'"
                        >
                          Cartao
                        </v-btn>
                        <v-btn
                          small
                          :color="methodSelected === 'pix' ? 'green' : 'grey lighten-2'"
                          :dark="methodSelected === 'pix'"
                          @click="methodSelected = 'pix'"
                        >
                          Pix
                        </v-btn>
                      </v-flex>

                      <div class="expande-horizontal wrap">
                        <v-flex class="pa-1" xs12>
                          <v-text-field outlined dense label="Nome do titular" v-model="payer.name" :rules="[v => !!v || 'Campo obrigatorio']"></v-text-field>
                        </v-flex>
                        <v-flex class="pa-1" xs12 md6>
                          <v-text-field outlined dense label="CPF/CNPJ" v-model="payer.cpfCnpj" :rules="[v => !!v || 'Campo obrigatorio']"></v-text-field>
                        </v-flex>
                        <v-flex class="pa-1" xs12 md6>
                          <v-text-field outlined dense label="E-mail" v-model="payer.email" :rules="[v => /.+@.+\..+/.test(v) || 'E-mail invalido']"></v-text-field>
                        </v-flex>
                        <v-flex class="pa-1" xs12 md6>
                          <v-text-field outlined dense label="Telefone" v-model="payer.phone" :rules="[v => !!v || 'Campo obrigatorio']"></v-text-field>
                        </v-flex>
                        <v-flex class="pa-1" xs12 md3>
                          <v-text-field outlined dense label="CEP" v-mask="['########']" v-model="payer.postalCode"></v-text-field>
                        </v-flex>
                        <v-flex class="pa-1" xs12 md3>
                          <v-text-field outlined dense label="Numero" v-model="payer.addressNumber"></v-text-field>
                        </v-flex>
                      </div>

                      <div class="expande-horizontal wrap" v-if="methodSelected === 'card'">
                        <v-flex class="pa-1" xs12>
                          <v-text-field outlined dense label="Nome impresso no cartao" v-model="payer.card.name" :rules="[v => !!v || 'Campo obrigatorio']"></v-text-field>
                        </v-flex>
                        <v-flex class="pa-1" xs12 md6>
                          <v-text-field outlined dense v-mask="['#### #### #### ####']" label="Numero do cartao" v-model="payer.card.number" :rules="[v => !!v || 'Campo obrigatorio']"></v-text-field>
                        </v-flex>
                        <v-flex class="pa-1" xs6 md2>
                          <v-select outlined dense :items="['01','02','03','04','05','06','07','08','09','10','11','12']" label="Mes" v-model="payer.card.expiryMonth" :rules="[v => !!v || 'Obrigatorio']"></v-select>
                        </v-flex>
                        <v-flex class="pa-1" xs6 md2>
                          <v-text-field outlined dense v-mask="['####']" label="Ano" v-model="payer.card.expiryYear" :rules="[v => !!v || 'Obrigatorio']"></v-text-field>
                        </v-flex>
                        <v-flex class="pa-1" xs6 md2>
                          <v-text-field outlined dense v-mask="['####']" label="CVV" v-model="payer.card.ccv" :rules="[v => !!v || 'Campo obrigatorio']"></v-text-field>
                        </v-flex>
                      </div>

                      <v-btn :loading="loading" block large class="fonte mt-4 text-none action-primary" color="blue lighten-1" dark @click="activateSubscription">
                        Ativar minha assinatura <v-icon class="ml-3" size="22">mdi-rocket</v-icon>
                      </v-btn>
                    </v-timeline-item>

                    <v-timeline-item fill-dot small :icon-color="$theme.primary" icon="mdi-cancel" color="#f2f2f2">
                      <v-btn :loading="loading" outlined class="text-none" color="red darken-1" @click="cancelSubscription">
                        Cancelar assinatura
                      </v-btn>
                    </v-timeline-item>
                  </v-timeline>
                </v-flex>
              </v-form>
            </v-flex>
          </div>
        </v-flex>
      </v-card>
    </v-flex>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      opened: false,
      methodSelected: "card",
      subscription: {
        methods: "",
        plan_id: {},
        creation_of_next_charge: ""
      },
      payer: {
        name: "",
        card: {
          name: "",
          number: "",
          expiryMonth: "",
          expiryYear: "",
          ccv: ""
        },
        cpfCnpj: "",
        email: "",
        postalCode: "",
        addressNumber: "",
        addressComplement: "",
        phone: ""
      },
      message: "",
      warning: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters(["getLoggedUser"])
  },
  methods: {
    activateSubscription() {
      if (!this.$refs.formSubscription.validate()) {
        return;
      }

      this.loading = true;
      this.subscription.method = this.methodSelected;

      this.$run("plans/activate-subscription", {
        subscription: this.subscription,
        payer: this.payer,
        method: this.methodSelected
      })
        .then(() => {
          this.loading = false;
          this.verifySub();
          alert("Assinatura processada com sucesso!");
        })
        .catch(err => {
          this.loading = false;
          alert(err.message || "Erro ao ativar assinatura, verifique os dados informados.");
          console.log(err);
        });
    },
    async cancelSubscription() {
      const confirmed = window.confirm("Tem certeza que deseja cancelar sua assinatura?");
      if (!confirmed) return;

      this.loading = true;
      try {
        await this.$run("subscription/deactivate-my-subscription");
        this.loading = false;
        await this.verifySub();
        alert("Assinatura cancelada com sucesso.");
      } catch (err) {
        this.loading = false;
        alert(err.message || "Erro ao cancelar assinatura.");
      }
    },
    filterStatusSubscription(val) {
      switch (val) {
        case "active":
          return "ativa";
        case "overdue":
          return "em atraso";
        case "canceled":
          return "cancelada";
        case "pending_payment":
          return "pendente de pagamento";
        default:
          return "pendente";
      }
    },
    loadSubscription({ closeWhenActive = false } = {}) {
      this.loading = true;
      return this.$run("subscription/view-my-subscription")
        .then(res => {
          const subscription = res.data || {};
          this.subscription = {
            ...this.subscription,
            ...subscription,
            plan_id: subscription.plan_id || {}
          };
          this.loading = false;

          if (subscription.current_status === "active") {
            this.message = "Sua assinatura foi ativada com sucesso.";
            this.opened = !closeWhenActive;
            this.warning = false;
          } else {
            this.message = "Sua assinatura esta pendente, realize o pagamento para liberar o acesso.";
            this.opened = true;
            this.warning = true;
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    async verifySub() {
      return this.loadSubscription({ closeWhenActive: true });
    },
    open() {
      this.opened = true;
      this.loadSubscription();
    },
    close() {
      this.opened = false;
    }
  }
};
</script>

<style>
.subscription-modern-card {
  border-radius: 16px !important;
  border: 1px solid #e9ecf5;
  box-shadow: 0 20px 35px rgba(15, 23, 42, 0.1);
}

.subscription-header {
  align-items: flex-start;
}

.action-primary {
  border-radius: 12px;
  letter-spacing: 0.2px;
}

.store-layout {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-height: 120px;
  cursor: pointer;
}

.store-cover {
  width: 100%;
  min-height: 220px;
  border-radius: 6px;
}

.profile-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 150px;
  height: 150px;
}

.store-profile {
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}

.store-profile:hover {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
}
.item-list-charge {
  background: #e6e4e4 !important;
  border-radius: 6px;
}
.change-method-icon-container {
  width: 80px;
  height: 80px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #f2f2f2;
}
.method-selected {
  box-shadow: -1px -2px 20px 2px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: -1px -2px 20px 2px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: -1px -2px 20px 2px rgba(0, 0, 0, 0.1);
  background: #9206b5 !important;
}
.change-method-icon-container {
  cursor: pointer;
}
</style>

